// 系统管理
const tools = [
  {
    path: '/tools/activate-date',
    name: 'activateDatePage',
    meta: { tag: 'SN激活信息查询' },
    component: () => import('@/pages/tools/ActivateDatePage')
  },
  {
    path: '/tools/nfc-format',
    name: 'nfcFormatPage',
    meta: { tag: 'NFC格式化提交' },
    component: () => import('@/pages/tools/NfcFormatPage')
  },
  {
    path: '/tools/file-export-history',
    name: 'FileExportHistory',
    meta: { tag: '导出文件下载' },
    component: () => import(`@/pages/tools/FileExportHistoryPage`)
  },
  {
    path: '/app-binds',
    name: 'appBindQuery',
    meta: { tag: 'APP绑定查询' },
    component: () => import('@/pages/tools/AppBindQueryPage')
  },
  {
    path: '/app-binds/un-bind',
    name: 'AppBindUnBind',
    meta: { tag: 'APP解绑' },
    component: () => import('@/pages/tools/AppBindUnBindPage')
  },
  {
    path: '/app-binds/un-bind-child',
    name: 'AppUnBindChild',
    meta: { tag: '儿童电话手表解绑' },
    component: () => import('@/pages/tools/AppUnBindChildPage')
  },
  {
    path: '/app-binds/bind-query-child',
    name: 'AppBindQueryChildPage',
    meta: { tag: '儿童电话手表绑定查询' },
    component: () => import('@/pages/tools/AppBindQueryChildPage')
  },
  {
    path: '/wechats/info',
    name: 'WechatInfo',
    meta: { tag: '微信步数查询' },
    component: () => import('@/pages/tools/WechatInfoPage')
  },
  {
    path: '/wechats/bind',
    name: 'WechatBind',
    meta: { tag: '微信绑定' },
    component: () => import('@/pages/tools/WechatBindPage')
  },
  {
    path: '/wechats/bind-query',
    name: 'WechatBindQuery',
    meta: { tag: '微信绑定查询' },
    component: () => import('@/pages/tools/WechatBindQueryPage')
  },
  {
    path: '/sns/update-import',
    name: 'SnUpdateImportPage',
    meta: { tag: 'SN批量修正' },
    component: () => import('@/pages/tools/SnUpdateImportPage')
  },
  {
    path: '/insurances/index',
    name: 'InsuranceQueryPage',
    meta: { tag: '德华安顾信息查询' },
    component: () => import('@/pages/tools/InsuranceQueryPage')
  }
]

export default tools
